export class TaxesModel {
    RowNum:number;
    IsAutoNumbering: boolean;  
    IsInserting: boolean;  
    TaxCode:string;
    Name:string;
    TaxFaction:number;
    Amount:number;
    TempName:string;
    Action:string
}